export interface UserModel {
  id: number;
  username: string;
  email: string;
  pic: string;
  roleId: number;
  phone: string;
  firstname: string;
  lastname: string;
}
